// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c7078eb3e41ef76010c30661a6d56cf8b9b9fdae.chunk.bundle.js";
};